import React from "react";
import { ShieldCheck } from "lucide-react";

const TermsCondition: React.FC<{ trialEligible: boolean }> = ({ trialEligible }) => {
  return (
    <React.Fragment>
      <section className="subscription-terms">
            <div className="subscription-terms__notice">
              <ShieldCheck size={19} aria-hidden="true" />
              <p>
                {trialEligible ? "By starting your free trial" : "By starting your subscription"}, you agree to the{" "}
                <a
                  href="https://www.thetradesmens.com/policies/privacy-policy.html"
                  target="_blank"
                  rel="noreferrer"
                >
                  Terms & Conditions
                </a>{" "}
                for the Contract Builder service. You can cancel anytime.
              </p>
            </div>
      </section>
    </React.Fragment>
  );
};

export default TermsCondition;
